import { Box } from '@chakra-ui/react';
import { getChakraReactSelectStyles } from '@udacity/chakra-uds-theme';
import { Option } from 'app/helpers/form-helper';
import { ChakraStylesConfig, Select } from 'chakra-react-select';
import React from 'react';

const PAGE_SIZE_OPTIONS = [
  { value: '10', label: '10' },
  { value: '20', label: '20' },
  { value: '50', label: '50' },
  { value: '100', label: '100' },
];

const DROPDOWN_WIDTH = '7rem';

// Pin the control and the dropdown to the same width so the closed and open
// states line up. The menu list inherits a large `minWidth` from Chakra's Menu
// theme, so we reset it to keep the popover the same width as the control.
const baseStyles = getChakraReactSelectStyles<Option>();
const pageSizeStyles: ChakraStylesConfig<Option, boolean> = {
  ...baseStyles,
  menu: (provided, state) => ({
    ...(baseStyles.menu?.(provided, state) ?? provided),
    width: '100%',
  }),
  menuList: (provided, state) => ({
    ...(baseStyles.menuList?.(provided, state) ?? provided),
    width: '100%',
    minWidth: 'unset',
  }),
};

export const PageSizeSelector: React.FC<{
  pageSize: number;
  onChangePageSize: (newPageSize: number) => void;
}> = ({ pageSize, onChangePageSize }) => {
  const onChange = (option: Option | null) => {
    return onChangePageSize(Number(option?.value || pageSize));
  };

  const currentPageSize = PAGE_SIZE_OPTIONS.find((opt) => opt.value === String(pageSize));

  return (
    <Box width={DROPDOWN_WIDTH}>
      <Select<Option>
        id="pagination-dropdown"
        chakraStyles={pageSizeStyles}
        value={currentPageSize}
        onChange={onChange}
        isClearable={false}
        options={PAGE_SIZE_OPTIONS}
      />
    </Box>
  );
};
